import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-popover-box',
  templateUrl: './popover-box.component.html',
  styleUrls: ['./popover-box.component.scss'],
})
export class PopoverBoxComponent implements OnInit {
  @Input() public isShow: boolean = false;
  @Output() public focusOut: EventEmitter<void> = new EventEmitter<void>();

  private isElementClicked = false;
  private isFirstRun = true;

  constructor() {}

  ngOnInit() {}

  public onFocusOut() {
    this.focusOut.emit();
  }

  @HostListener('click')
  clickedInsideElement() {
    this.isElementClicked = true;
  }

  @HostListener('document:click')
  clickedOutsideElement() {
    if (!this.isElementClicked && !this.isFirstRun) {
      this.onFocusOut();
    }
    this.isElementClicked = false;
    this.isFirstRun = false;
  }
}
